import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { noPaddingAllTypes } from "../../constants";

function Section(props) {
  const hrClasses = classNames(
    "section",
    {
      [`section-${props.theme}`]: props.theme,
      [`padding-${props.padding}`]: props.padding,
      [`margin-${props.margin}`]: props.margin
    },
    props.className
  );

  return React.createElement(
    "div",
    {
      className: hrClasses
    },
    props.children
  );
}

Section.defaultProps = {
  theme: "normal",
  padding: false,
  margin: false
};

const paddingAdded = ["m", "m-top", "m-top-bottom", "m-bottom"];

Section.propTypes = {
  theme: PropTypes.oneOf([
    "normal",
    "white",
    "default",
    "warning",
    "error",
    "success",
    "dark",
    "info"
  ]),
  padding: PropTypes.oneOf([...noPaddingAllTypes, ...paddingAdded]),
  margin: PropTypes.oneOf(noPaddingAllTypes),
  className: PropTypes.string,
  children: PropTypes.node
};

export default Section;
